import * as React from "react";
import { connect } from "react-redux";

import ChemistPayment from "../../screens/Chemist/ChemistPayment";
import {
  ChemistPaymentList,
  ChemistPaymentSelectedPage,
  ChemistPaymentStatusChange,
} from "./action";
class ChemistPaymentContainer extends React.Component<Props, State> {
  render() {
    return (
      <ChemistPayment
        chemistPaymentList={this.props.ChemistPaymentList}
        chemistPaymentDtlsList={this.props.chemistPaymentDtlsList}
        chemistPaymentDtlsCount={this.props.chemistPaymentDtlsCount}
        ChemistPaymentSelectedPage={this.props.ChemistPaymentSelectedPage}
        ChemistPaymentStatusChange={this.props.ChemistPaymentStatusChange}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    ChemistPaymentList: (value) => {
      dispatch(ChemistPaymentList(value));
    },
    ChemistPaymentSelectedPage: value => {
      dispatch(ChemistPaymentSelectedPage(value));
    },
    ChemistPaymentStatusChange: value => {
      dispatch(ChemistPaymentStatusChange(value));
    },
  };
}
function mapStateToProps(state) {
  return {
    chemistPaymentDtlsList: state.ChemistPaymentReducer.chemistPaymentDtlsList,
    chemistPaymentDtlsCount: state.ChemistPaymentReducer.chemistPaymentDtlsCount,
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(ChemistPaymentContainer);
